// ========= START: src/components/Modal.js (COMPLETE REPLACEMENT) =========
import React from 'react';
import './Modal.css';

// MODIFICATION: Added previewImage, confirmText, and cancelText props for more flexibility
function Modal({ isOpen, onClose, onConfirm, title, children, previewImage, confirmText = 'Confirm', cancelText = 'Cancel' }) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-panel" onClick={(e) => e.stopPropagation()}>
        <h2 className="modal-title">{title}</h2>
        
        {/* NEW: Conditionally render a preview image if the prop is provided */}
        {previewImage && (
          <div className="modal-image-container">
            <img src={previewImage} alt="Item Preview" className="modal-preview-image" />
          </div>
        )}

        <div className="modal-content">
          {children}
        </div>
        <div className="modal-actions">
          {/* MODIFICATION: Conditionally render the cancel button */}
          {cancelText && (
            <button className="modal-button cancel" onClick={onClose}>
              {cancelText}
            </button>
          )}
          {/* MODIFICATION: Conditionally render the confirm button */}
          {confirmText && (
            <button className="modal-button confirm" onClick={onConfirm}>
              {confirmText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default Modal;
// ========= END: src/components/Modal.js (COMPLETE REPLACEMENT) =========